export const jobOne = {
  name: "OMS - Training/Audit Documentation Manger",
  achievements: [
    "Directed implementation and deployment of the system, reducing a minimum of 500 monthly labor hours.",
    "Designed, documented, and developed web-based software application to save over 200k yearly.",
    "Lead transition from Django, to DRF and Next JS Frontend in the span of 1 month.",
    "Planned and engineered over 200 RESTful endpoints to extract data.",
    "Reduced 85% of manually data collection and reporting by implementing a dashboard feature.",
    "Created 100+ accurate and successful test scripts to manage automated testing.",
    "Improved render time by 25% by transferring filtering from the client side to the server side.  ",
    "Analyzed and vetted the data collected to ensure data was a 100% accurate.",
  ],
}
export const jobTwo = {
  name: "VAST – Warehouse Productivity Tracker",
  achievements: [
    "Collaborated with 2 team members in the transition from JavaScript to TypeScript.",
    "Communicated with internal teams, and lead meetings regarding the development progress.",
    "Automated 100+ test cases using Cypress based on user stories.",
    "Presented and transitioned design to meet company standards, maintaining accessibility colors at 7:1 ratio.",
    "Diagnosed excessive re-renders with React DevTools and WDYR reducing re-renders from 6+ to 1.",
    "Refactored code blocks optimizing time complexity from O(n2) to O(n), increasing performance by at least 2x.",
    "Trained, guided, and provided documentation to 40+ employees from different departments",
  ],
}

export const education = {
  college: "Southern New Hampshire University",
  location: "Manchester, NH",
  major: "BS Computer Science with concentration in Software Engineering",
  minor: "Project Management. In-major GPA: 3.5",
  courseWork: [
    "Software Development Life Cycle",
    "App Development",
    "System Analysis and Design",
    "Data Structures & Algorithms",
    "AI & ML",
    "UI/UX Design and Development",
  ],
}

export const technicalExperience = [
  {
    name: "Mythus",
    date: "August 2022 - Present",
    description:
      "Designed and deployed web-based application that features a job board, and resume builder.",
    stack: ["Rust", "Python", "SQL", "Typescript", "Tailwind CSS"],
    href: "https://www.mythus.io/",
  },
  {
    name: "rodrez.com",
    date: "June 2021 – Present",
    description:
      "Personal blog-like website to write technical articles about data structures, algorithms, and Big O notation.",
    stack: ["JavaScript (Svelte)", "Rust", " Python"],
    href: "https://www.rodrez.com/",
  },
  {
    name: "Rustnamer",
    date: "September 2022",
    description:
      "Developed and released desktop app where users can bulk rename files based on patterns. Authored documentation to demonstrate open-source collaboration. Configured CI/CD pipeline to automate releases with GitHub Actions.",
    stack: ["Rust (Tauri)", "JavaScript (React)", "Vite", "Github Actions"],
    href: "https://github.com/rodrez/rustnamer",
  },
]

export const languages = {
  proficient: ["Python", "Javascript", "Typescript"],
  familiar: ["SQL", "Rust", "C++", "Lua"],
  novice: ["Java"],
}

export const technologies = {
  proficient: ["VS Code", "PyCharm", "Git", "Linux/Unix", "VIM"],
  familiar: ["Docker", ""],
}
